module.exports = __webpack_public_path__ + "static/media/fun-cards-logo.b191a5db.webp";